import { DataTypeEnum, DropdownTypeEnum, IDropdownOptions, IGridColumns, IGridConfig, StepInterface } from "@poste-click-connect/shared-ui";
import { IdCausalListEnum, IdListaEnum, IdStateEnum, LabelCausalListEnum, LabelListaEnum, LabelStateEnum, PayloadStateEnum, StepperIdEnum, StepperLabelEnum } from "../enums/on-consignment.enum";
import { IdFillBoxOption, LabelFillBoxOption } from "../enums/dropdown-enum";

export const initialStepperData: StepInterface[] = [
  {
    id: StepperIdEnum.COMPONI_SCATOLA,
    label: StepperLabelEnum.COMPONI_SCATOLA,
    isActive: true,
    isCompleted: false,
  },
  {
    id: StepperIdEnum.RIEMPI_SCATOLA,
    label: StepperLabelEnum.RIEMPI_SCATOLA,
    isActive: false,
    isCompleted: false,
  },
  {
    id: StepperIdEnum.STAMPA_CODICE_PACCO,
    label: StepperLabelEnum.STAMPA_CODICE_PACCO,
    isActive: false,
    isCompleted: false,
  },
  {
    id: StepperIdEnum.ACCETTA_PACCO,
    label: StepperLabelEnum.ACCETTA_PACCO,
    isActive: false,
    isCompleted: false,
  },
  {
    id: StepperIdEnum.RIEPILOGO,
    label: StepperLabelEnum.RIEPILOGO,
    isActive: false,
    isCompleted: false,
  }
];

export const stepperDataNoSummary: StepInterface[] = [
  {
    id: StepperIdEnum.COMPONI_SCATOLA,
    label: StepperLabelEnum.COMPONI_SCATOLA,
    isActive: true,
    isCompleted: false,
  },
  {
    id: StepperIdEnum.RIEMPI_SCATOLA,
    label: StepperLabelEnum.RIEMPI_SCATOLA,
    isActive: false,
    isCompleted: false,
  },
  {
    id: StepperIdEnum.STAMPA_CODICE_PACCO,
    label: StepperLabelEnum.STAMPA_CODICE_PACCO,
    isActive: false,
    isCompleted: false,
  },
  {
    id: StepperIdEnum.ACCETTA_PACCO,
    label: StepperLabelEnum.ACCETTA_PACCO,
    isActive: false,
    isCompleted: false,
  },
]

export const causalListOption: IDropdownOptions<any>[] = [
  {
    id: IdCausalListEnum.SATURAZIONE_SCATOLA,
    label: LabelCausalListEnum.SATURAZIONE_SCATOLA,
    payload: LabelCausalListEnum.SATURAZIONE_SCATOLA
  },
  {
    id: IdCausalListEnum.CHIUSURA_STRAORDINARIA,
    label: LabelCausalListEnum.CHIUSURA_STRAORDINARIA,
    payload: LabelCausalListEnum.CHIUSURA_STRAORDINARIA
  },
  {
    id: IdCausalListEnum.CHIUSURA_FERIE,
    label: LabelCausalListEnum.CHIUSURA_FERIE,
    payload: LabelCausalListEnum.CHIUSURA_FERIE
  }
];

export const stateListOption: IDropdownOptions<any>[] = [
  {
    id: IdStateEnum.TUTTI,
    label: LabelStateEnum.TUTTI,
    payload: PayloadStateEnum.TUTTI,
    isSelectAll: true
  },
  {
    id: IdStateEnum.IN_CONTO_DEPOSITO,
    label: LabelStateEnum.IN_CONTO_DEPOSITO,
    payload: PayloadStateEnum.IN_CONTO_DEPOSITO
  },
  {
    id: IdStateEnum.IN_VERIFICA,
    label: LabelStateEnum.IN_VERIFICA,
    payload: PayloadStateEnum.IN_VERIFICA
  },
  {
    id: IdStateEnum.AFFIDATI,
    label: LabelStateEnum.AFFIDATI,
    payload: PayloadStateEnum.AFFIDATI
  },
  {
    id: IdStateEnum.SMARRITO,
    label: LabelStateEnum.SMARRITO,
    payload: PayloadStateEnum.SMARRITO
  }
];

export const viewListOption: IDropdownOptions<any>[] = [
  {
    id: IdListaEnum.BENI_CONTO_DEPOSITO,
    label: LabelListaEnum.BENI_CONTO_DEPOSITO,
    payload: LabelListaEnum.BENI_CONTO_DEPOSITO
  },
  {
    id: IdListaEnum.STORICO,
    label: LabelListaEnum.STORICO,
    payload: LabelListaEnum.STORICO
  },
];

export const gridColumnsOnConsignment: IGridColumns[] = [
  {
    key: 'bustaCode',
    label: 'Codice busta',
    type: DataTypeEnum.STRING,
    hasSort: true,
  },
  {
    key: 'amazonCode',
    label: 'Codice Amazon',
    type: DataTypeEnum.STRING,
    hasSort: true,
  },
  {
    key: 'boxCode',
    label: 'Codice scatola',
    type: DataTypeEnum.STRING,
    hasSort: true,
  },
  {
    key: 'dataScadenza',
    label: 'Data scadenza',
    type: DataTypeEnum.DATA,
    hasSort: true,
  },
  {
    key: 'stato',
    label: 'Stato',
    type: DataTypeEnum.STRING,
    hasSort: true,
  }
];

export const gridColumnsOnConsignmentHistorical: IGridColumns[] = [
  {
    key: 'numberOffice',
    label: 'Progressivo ufficio',
    type: DataTypeEnum.STRING,
    hasSort: false,
  },
  {
    key: 'dataStartDeposito',
    label: 'Data inizio deposito',
    type: DataTypeEnum.DATA,
    hasSort: false,
  },
  {
    key: 'amazonCode',
    label: 'Codice Amazon',
    type: DataTypeEnum.STRING,
    hasSort: false,
  },
  {
    key: 'bustaCode',
    label: 'Codice busta',
    type: DataTypeEnum.STRING,
    hasSort: false,
  },
  {
    key: 'description',
    label: 'Descrizione prodotto',
    type: DataTypeEnum.STRING,
    hasSort: false,
  },
  {
    key: 'lastState',
    label: 'Ultimo stato',
    type: DataTypeEnum.STRING,
    hasSort: false,
  },
  {
    key: 'dataScadenza',
    label: 'Data ultimo stato',
    type: DataTypeEnum.STRING,
    hasSort: false,
  },
  {
    key: 'boxCode',
    label: 'Codice scatola',
    type: DataTypeEnum.STRING,
    hasSort: false,
  },
  {
    key: 'destinatario',
    label: 'Destinatario',
    type: DataTypeEnum.STRING,
    hasSort: false,
  }
];

export const gridColumnsFillBox: IGridColumns[] = [
  {
    key: 'bustaCode',
    label: 'Codice busta',
    type: DataTypeEnum.STRING,
    hasSort: false,
  },
  {
    key: 'amazonCode',
    label: 'Codice Amazon',
    type: DataTypeEnum.STRING,
    hasSort: false,
  },
  {
    key: 'dataScadenza',
    label: 'Data di scadenza',
    type: DataTypeEnum.DATA,
    hasSort: false,
  },
  {
    key: 'stato',
    label: 'Stato oggetto',
    type: DataTypeEnum.DROPDOWN,
    hasSort: false,
  }
];

export const gridConfig: IGridConfig = {
  evenRowClass: 'even-row',
  errorRowClass: 'warning-row'
}

export const optionConfigGridFillBox: IDropdownOptions<any>[] = [
  {id: IdFillBoxOption.SCANSIONA_OGGETTO, payload: LabelFillBoxOption.SCANSIONA_OGGETTO, label: LabelFillBoxOption.SCANSIONA_OGGETTO, disabled: false, iconType: DropdownTypeEnum.WARNING},
  {id: IdFillBoxOption.OGGETTO_SMARRITO, payload: LabelFillBoxOption.OGGETTO_SMARRITO, label: LabelFillBoxOption.OGGETTO_SMARRITO, disabled: false, iconType: DropdownTypeEnum.ERROR},
]

export const optionConfigGridFillBoxScan: IDropdownOptions<any>[] = [
  {id: IdFillBoxOption.OGGETTO_SCATOLA, payload: LabelFillBoxOption.OGGETTO_SCATOLA, label: LabelFillBoxOption.OGGETTO_SCATOLA, disabled: false, iconType: DropdownTypeEnum.SUCCESS},
]

export const exportStatusFlyer: any = {
  "IN CONTO DEPOSITO": 1,
  "IN VERIFICA": 2,
  "INVIATI": 3,
  "SMARRITI": 4
}
